import * as React from "react";
import type { SVGProps } from "react";
const SvgKey02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 9h.121m8.88 12.6-6.693-6.598c-1.295.502-2.842.305-4.28-.115-3.423-1.002-5.375-4.55-4.36-7.925 1.017-3.374 4.616-5.298 8.04-4.297s5.375 4.55 4.359 7.924l-.16.866 6.693 6.597V21.6z"
    />
  </svg>
);
export default SvgKey02;
